import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LayoutDashboard, Briefcase, Building2, FileText, Users, Clock, CircleDot, Mail, MessageSquare, Settings, LogOut, ExternalLink, Menu, X } from 'lucide-react';

const navItems = [
  { path: '/panel-abbasov/dashboard', label: 'Panel', icon: LayoutDashboard },
  { path: '/panel-abbasov/services', label: 'Xidmətlər', icon: Briefcase },
  { path: '/panel-abbasov/projects', label: 'Layihələr', icon: Building2 },
  { path: '/panel-abbasov/blog', label: 'Bloq', icon: FileText },
  { path: '/panel-abbasov/doctors', label: 'Həkimlər', icon: Users },
  { path: '/panel-abbasov/timeline', label: 'Karyera', icon: Clock },
  { path: '/panel-abbasov/pills', label: 'Ana səhifə düymələri', icon: CircleDot },
  { path: '/panel-abbasov/contacts', label: 'Müraciətlər', icon: Mail },
  { path: '/panel-abbasov/chats', label: 'Söhbətlər', icon: MessageSquare },
  { path: '/panel-abbasov/settings', label: 'Ayarlamalar', icon: Settings },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Yüklənir...</div>;
  if (!user) return <Navigate to="/panel-abbasov" replace />;

  const doLogout = () => { logout(); nav('/panel-abbasov'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f8fafc' }}>
      <aside data-open={open} style={{
        width: 240, background: '#1e3d3d', color: '#fff',
        display: 'flex', flexDirection: 'column',
        position: 'sticky', top: 0, height: '100vh', overflowY: 'auto',
      }} className="admin-sidebar">
        <div style={{ padding: '22px 20px 18px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ fontSize: 18, fontWeight: 700 }}>Admin Panel</div>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', marginTop: 4 }}>@{user.username}</div>
        </div>
        <nav style={{ display: 'flex', flexDirection: 'column', padding: '12px 8px', flex: 1 }}>
          {navItems.map((n) => (
            <NavLink key={n.path} to={n.path} onClick={() => setOpen(false)}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '10px 14px', borderRadius: 8, textDecoration: 'none',
                color: isActive ? '#fff' : 'rgba(255,255,255,0.75)',
                background: isActive ? '#17b4b4' : 'transparent',
                fontSize: 14, fontWeight: 600, marginBottom: 4,
                transition: 'background 150ms ease',
              })}>
              <n.icon size={17} />{n.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding: 12, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <a href="/" target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', color: 'rgba(255,255,255,0.7)', textDecoration: 'none', fontSize: 13, borderRadius: 6, marginBottom: 4 }}>
            <ExternalLink size={14} /> Sayta bax
          </a>
          <button onClick={doLogout} style={{ width: '100%', background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', color: '#fff', padding: '8px 10px', borderRadius: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
            <LogOut size={14} /> Çıxış
          </button>
        </div>
      </aside>
      <button className="admin-menu-btn" onClick={() => setOpen(!open)}
        style={{ display: 'none', position: 'fixed', top: 12, left: 12, zIndex: 60, background: '#17b4b4', border: 'none', color: '#fff', padding: 10, borderRadius: 8, cursor: 'pointer' }}>
        {open ? <X size={18} /> : <Menu size={18} />}
      </button>
      <main style={{ flex: 1, padding: '28px 32px', minWidth: 0 }} className="admin-main">
        <Outlet />
      </main>
      <style>{`
        .spin { animation: spin 1s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 768px) {
          .admin-sidebar { position: fixed !important; z-index: 55; transform: translateX(-100%); transition: transform 250ms ease; }
          .admin-sidebar[data-open="true"] { transform: translateX(0); }
          .admin-menu-btn { display: inline-flex !important; }
          .admin-main { padding: 60px 18px 24px !important; }
        }
      `}</style>
    </div>
  );
}
